import consultaEs from './locales/es/consulta.json' with { type: 'json' };
import consultaEn from './locales/en/consulta.json' with { type: 'json' };
import cajaEs from './locales/es/caja.json' with { type: 'json' };
import cajaEn from './locales/en/caja.json' with { type: 'json' };
import fuentesEs from './locales/es/fuentes.json' with { type: 'json' };
import fuentesEn from './locales/en/fuentes.json' with { type: 'json' };
import cuentasEs from './locales/es/cuentas.json' with { type: 'json' };
import cuentasEn from './locales/en/cuentas.json' with { type: 'json' };
import mapaEs from './locales/es/mapa.json' with { type: 'json' };
import mapaEn from './locales/en/mapa.json' with { type: 'json' };
import adminEs from './locales/es/admin.json' with { type: 'json' };
import adminEn from './locales/en/admin.json' with { type: 'json' };

/**
 * Los diccionarios de la web, cargados de golpe.
 *
 * Son dos idiomas y unos cuantos kilobytes: cargarlos por red partiría la primera pintada en dos y
 * dejaría un hueco donde va el texto. El idioma vive en `localStorage['athena-lang']` y en el
 * atributo `lang` del `<html>`, sin prefijo de ruta (`plan/F4-web.md`).
 */
export const IDIOMAS = ['es', 'en'] as const;
export type Idioma = (typeof IDIOMAS)[number];

export const CLAVE_IDIOMA = 'athena-lang';

const DICCIONARIOS = {
  es: { consulta: consultaEs, caja: cajaEs, fuentes: fuentesEs, cuentas: cuentasEs, mapa: mapaEs, admin: adminEs },
  en: { consulta: consultaEn, caja: cajaEn, fuentes: fuentesEn, cuentas: cuentasEn, mapa: mapaEn, admin: adminEn },
} as const;

export type Diccionario = (typeof DICCIONARIOS)['es'];

export function diccionarioDe(idioma: Idioma): Diccionario {
  return DICCIONARIOS[idioma];
}

/**
 * El idioma que toca: el guardado, si vale; si no, el del navegador; si no, español.
 *
 * Español por defecto y no inglés porque Athena la hace Sinapser desde España y su primer público
 * es el sector español, aunque el corpus esté en inglés.
 */
export function idiomaInicial(guardado: string | null, delNavegador: string | undefined): Idioma {
  if (esIdioma(guardado)) return guardado;
  const corto = (delNavegador ?? '').slice(0, 2).toLowerCase();
  return esIdioma(corto) ? corto : 'es';
}

export function esIdioma(valor: string | null | undefined): valor is Idioma {
  return valor === 'es' || valor === 'en';
}
